import { CartType } from '@/types/cartTypes';
import * as React from 'react';

export const CartContext = React.createContext(
  undefined as {
    cart: undefined | CartType;
    setCart: React.Dispatch<React.SetStateAction<CartType | undefined>>;
  }
);
